// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__vDOp2","form":"Profile_form__EXEiy","group":"Profile_group__7Lq4W"};